export default __webpack_public_path__ + "static/media/transactionSucceeded.87ff72a6.svg";